import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import { FornecedorCotacaoValorEnvio } from '../../models/supplier-portal.model'

// Cotação no Portal do Fornecedor — resource próprio (api/FornecedorPortalCotacao), separado do
// SupplierPortalService pelo mesmo motivo que o backend separou o módulo: é outro domínio.
// Nenhuma rota aceita fornecedorId; o fornecedor é resolvido pelo usuário logado.
// A recusa de trecho (POST /{id}/recusar) existe no backend mas está em standby — não expor aqui
// enquanto o modal de recusa não for construído.
@Injectable({
  providedIn: 'root',
})
export class SupplierPortalQuoteService {
  private baseUrl = environment.baseUrl
  private resource = 'FornecedorPortalCotacao'

  constructor(private httpClient: HttpClient) {}

  // statusId 0 traz todos os status — o backend só filtra quando vem maior que zero.
  public listPagedCotacoes(
    page: number,
    rows = 10,
    statusId = 0,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}&statusId=${statusId}`,
    )
  }

  // Devolve { origem, paradas[], destino } no mesmo formato de CompraSolicitacaoItinerario.
  public getItinerario(itemCotacaoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${itemCotacaoId}/itinerario`,
    )
  }

  // Resposta definitiva do fornecedor: o item vai a "Valor Recebido" e trava.
  public registrarValor(
    itemCotacaoId: string,
    model: FornecedorCotacaoValorEnvio,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${itemCotacaoId}/valor`,
      model,
    )
  }
}
